import { useQuery } from '@tanstack/react-query'
import { getNoticeDetailApi, getNoticeListApi } from '@/api/noticeApi'

/* 공지사항 목록 조회 */
export const useNoticeList = () => {
  return useQuery({
    queryKey: ['noticeList'],
    queryFn: () => getNoticeListApi(),
    retry: false
  })
}

/** 공지사항 상세 조회 */
export const useNoticeDetail = (noticeId: number) => {
  return useQuery({
    queryKey: ['noticeDetail', noticeId],
    queryFn: () => getNoticeDetailApi(noticeId),
    enabled: false
  })
}
